import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Screen from '@/styles/Themes/Screen';
import { borders, radius } from '@/styles/Themes/Metrics';
import Text from '@/styles/Themes/Text';

export const VContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    ${Screen.desktop} {
        gap: 24px;
        flex-direction: row;
    }
`;

export const VInfoContainer = styled.div`
    background-color: ${cssVars.bg_white_blue};
    border-radius: ${radius.small};
    box-shadow: ${cssVars.shadow_card_default};
    padding: 16px 20px 20px;
    margin: 16px 0 0;
    width: 100%;

    ${Screen.desktop} {
        max-width: 340px;
        height: 480px;
        padding: 24px;
        margin: 0;
    }
`;

export const VBookNowButtonContainer = styled.div`
    width: 100%;
`;

export const VDivider = styled.div`
    width: 100%;
    border-bottom: ${borders.small} ${cssVars.bg_gray4_dark2};
    margin: 20px 0 16px;
    ${Screen.desktop} {
        margin: 24px 0;
    }
`;

export const VDescriptionContainer = styled.div`
    display: grid;
    align-items: center;
    width: 90%;
    grid-gap: 25px;
`;

export const PriceContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    ${Text.Full.heading3};
    color: ${cssVars.fg_gray2_gray3};
    margin-bottom: 16px;
    min-height: 42px;
`;
